<div class="global_container">
  @if (isAuthenticated && activeRoute !== 'auth') {
    <app-header></app-header>
  }
  <div class="main_content_wrapper">
    @if (isAuthenticated && activeRoute !== 'auth') {
      <app-side-nav
      ></app-side-nav>
    }
    <div class="content-area">
      <router-outlet></router-outlet>
    </div>
    @if (isAuthenticated && activeRoute !== 'auth') {
      <app-support-chat
        style="position: fixed; bottom: 2rem; right: 2rem; z-index: 1000"
      ></app-support-chat>
    }
  </div>
  <app-verify-email-modal></app-verify-email-modal>
  <app-windows-waitlist-modal></app-windows-waitlist-modal>
  <activity-log-modal></activity-log-modal>
  <app-toast></app-toast>
</div>
